import { getInitials, getStatusColor } from "@/utils/activityUtils";
import { cn } from "@/utils/cn";

interface UserAvatarProps {
  name: string;
  isCheckedIn?: boolean;
  isCurrentlyPaused?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
};

export function UserAvatar({
  name,
  isCheckedIn = false,
  isCurrentlyPaused = false,
  size = "md",
  className,
}: UserAvatarProps) {
  const statusColor = getStatusColor(isCheckedIn, isCurrentlyPaused);
  const initials = getInitials(name);

  return (
    <div className={cn("relative inline-flex", className)}>
      <div
        className={cn(
          "flex items-center justify-center rounded-full bg-surface-overlay font-semibold text-text-secondary",
          sizeClasses[size]
        )}
        style={{
          boxShadow: `0 0 0 2px var(--color-surface-raised), 0 0 0 4px ${statusColor}`,
        }}
      >
        {initials}
      </div>
      <span
        className="absolute -bottom-0.5 -right-0.5 block h-3 w-3 rounded-full border-2"
        style={{
          backgroundColor: statusColor,
          borderColor: "var(--color-surface-raised)",
        }}
      />
    </div>
  );
}
